import { createGlobalStyle } from 'styled-components';

import Gothic from '@/assets/fonts/gothic.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gothic';
    src: url(${Gothic});
  }   
  
  .generated-images-holder-var2 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var2 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .right-text-var2 {
    overflow: hidden;
    height: 100%;
    background-color: white;
    padding: 33px;
    line-height: 1.2;
    width: 50%;
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: -0.05em;
  }
  .break-var2 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  .half-image-var2 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    &--reversed {
      order: 2;
    }
  }
  .left-actual-photo-var2 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
    z-index: 1;
    &--reversed {
      right: 0;
      left: auto;
    }
  }
  .left-actual-photo-var2--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
